import {Presenter} from '../../../support/with_presenter';
import {PartEvent} from '../../../models/PartEvent';
import {map, Observable, Subscription} from 'rxjs';
import {Chapter} from '../../../models/Chapter';

export interface ChapterAdder {
    add(chapter: Chapter): void;
}

export interface EventInteractor {
    events: Observable<PartEvent[]>;

    add(event: PartEvent): void;

    delete(event: PartEvent): void;
}

export class EventListPresenter implements Presenter {
    public addEventWizardVisible = false;
    public addChapterWizardVisible: boolean = false;

    public events: PartEvent[] = [];

    private subscription: Subscription | undefined;

    constructor(
        private expandedPartUuid: string,
        private eventInteractor: EventInteractor,
        private chapterAdder: ChapterAdder,
    ) {}

    public mount(): void {
        this.subscription = this.eventInteractor.events
            .pipe(map((events) => events.filter((event) => event.anchor.__expandedPartUuid === this.expandedPartUuid)))
            .subscribe((events) => (this.events = events));
    }

    public unmount(): void {
        this.subscription?.unsubscribe();
    }

    public onAddEventClick() {
        this.addEventWizardVisible = true;
    }

    public onCancelAddEventWizard() {
        this.addEventWizardVisible = false;
    }

    public onAddEvent(partEvent: PartEvent) {
        this.eventInteractor.add(partEvent);
        this.addEventWizardVisible = false;
    }

    public onTrashEvent(event: PartEvent) {
        this.eventInteractor.delete(event);
    }

    public onAddChapterClick() {
        this.addChapterWizardVisible = true;
    }

    public onAddChapter(chapter: Chapter) {
        this.chapterAdder.add(chapter);
        this.addChapterWizardVisible = false;
    }

    public onCancelAddChapterWizard() {
        this.addChapterWizardVisible = false;
    }
}
